export const CrownIcon = ({
	color = 'var(--theme-primary)',
	width = '24',
	height = '24',
	...props
}): JSX.Element => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<path
			d="M19.875 8.46875C19.875 9.09766 19.3828 9.5625 18.7812 9.5625C18.7539 9.5625 18.7539 9.5625 18.7539 9.5625L17.3594 17.1641C17.3047 17.5742 16.9219 17.875 16.5117 17.875H7.46094C7.05078 17.875 6.66797 17.5742 6.61328 17.1641L5.21875 9.5625C5.21875 9.5625 5.21875 9.5625 5.19141 9.5625C4.58984 9.5625 4.09766 9.09766 4.09766 8.46875C4.09766 7.86719 4.58984 7.375 5.19141 7.375C5.76562 7.375 6.28516 7.86719 6.28516 8.46875C6.28516 8.71484 6.17578 8.93359 6.03906 9.125L8.5 11.0938C8.9375 11.4219 9.56641 11.2852 9.8125 10.793L11.3984 7.64844C11.0977 7.45703 10.8789 7.12891 10.8789 6.71875C10.8789 6.11719 11.3711 5.625 12 5.625C12.6016 5.625 13.0664 6.11719 13.0664 6.71875C13.0664 7.12891 12.8477 7.45703 12.5195 7.64844L14.1055 10.793C14.3516 11.2852 15.0078 11.4219 15.4453 11.0938L17.8789 9.125C17.7695 8.93359 17.6875 8.71484 17.6875 8.46875C17.6875 7.86719 18.1523 7.375 18.7812 7.375C19.3828 7.375 19.875 7.86719 19.875 8.46875Z"
			fill={color}
		/>
	</svg>
)
